export const business = {
  name: 'East End Automotive Repair LLC',
  shortName: 'East End Automotive',
  contact: 'The East End Team',
  phone: '(865) 206-2279',
  phoneHref: 'tel:+18652062279',
  smsHref: 'sms:+18652062279',
  email: 'service@eeautomotiverepair.com',
  address: {
    street: '274 Warehouse Rd',
    city: 'Oak Ridge',
    state: 'TN',
    zip: '37830',
  },
  hours: [
    { days: 'Monday – Friday', time: '8:00 AM – 5:00 PM' },
    { days: 'Saturday', time: 'Closed' },
    { days: 'Sunday', time: 'Closed' },
  ],
  logoUrl:
    'https://cdn.magicpatterns.com/uploads/c3ysWqyXY8gP4LQfgjSHac/clipboard.png',
  websiteUrl: 'https://www.eeautomotiverepair.com/',
}

export const socials = [
  { label: 'Facebook', href: 'https://www.facebook.com/EastEndautorepair' },
  { label: 'Instagram', href: 'https://www.instagram.com/eastendautorepair1' },
  { label: 'TikTok', href: 'https://www.tiktok.com/@eastendautomotiverepair' },
  {
    label: 'SureCritic',
    href: 'https://www.surecritic.com/reviews/east-end-automotive-repair-llc',
  },
]

export const tiktokTips = {
  handle: '@eastendautomotiverepair',
  displayName: 'EastEndAutoRepair',
  profileUrl: 'https://www.tiktok.com/@eastendautomotiverepair',
  videoUrl:
    'https://www.tiktok.com/@eastendautomotiverepair/video/7530843712373525790',
  embedUrl: 'https://www.tiktok.com/embed/v2/7530843712373525790',
  thumbnailUrl:
    'https://cdn.magicpatterns.com/uploads/bc3JzjvgVzmAzQ3Mwh7o2i/tiktok-thumbnail.jpg',
  caption: 'Cabin air filter creating a restriction, causing poor air flow.',
}

export const reviewSummary = {
  rating: '5.0',
  count: 93,
  nps: 98,
  source: 'SureCritic',
  url: 'https://www.surecritic.com/reviews/east-end-automotive-repair-llc',
}

export const reviewDistribution = [
  { stars: '5 star', share: '97%', width: '97%' },
  { stars: '4 star', share: '2%', width: '2%' },
  { stars: '3 star', share: 'Less than 1%', width: '1%' },
  { stars: '2 star', share: 'Less than 1%', width: '1%' },
  { stars: '1 star', share: 'Less than 1%', width: '1%' },
]

export const reviewThemes = [
  {
    title: 'Clear explanations',
    copy: 'Customers describe findings being explained in language they can follow.',
  },
  {
    title: 'Fair pricing',
    copy: 'Pricing comes up as a reason customers return to the shop.',
  },
  {
    title: 'Transparent recommendations',
    copy: 'Recommendations are laid out so customers can decide what to do next.',
  },
  {
    title: 'Professional work',
    copy: 'The quality of the repair work is a recurring point in reviews.',
  },
  {
    title: 'Kindness',
    copy: 'How customers are treated at the counter shows up repeatedly.',
  },
  {
    title: 'Communication',
    copy: 'Keeping customers informed through the visit is a consistent theme.',
  },
]

export const photos = {
  heroExterior:
    'https://cdn.magicpatterns.com/uploads/uPELxjhUbSuMWrcPx65ePw/east-end-twilight-hero-cleaned.png',
  diagnosticMercedes:
    'https://cdn.magicpatterns.com/uploads/sENUj1pdPyP1qqGG7iShGB/top-image.jpg',
  consultation:
    'https://cdn.magicpatterns.com/uploads/xjJzXBtUtMq56AsSQYW5oQ/clipboard.png',
  fullBuilding:
    'https://cdn.magicpatterns.com/uploads/2gXjuY7NNbqbFADnEBF6ss/full_building.jpg',
  building:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/EAST-END-AUTOMOTIVE-REPAIR-LLC-BUILDING.jpg',
  shopMechanic:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/ficing-car.jpg',
  clipboard:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/Mechanic-holding-clipboard.png',
  truck:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/truck-getting-repair.jpg',
  whiteCar:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2025/06/white-car-getting-repaired.jpg',
  condition:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2026/04/condition-image.jpg',
  cause:
    'https://eeautomotiverepair.com/wp-content/uploads/sites/860/2026/04/cause-image.jpg',
}

export const navLinks = [
  { label: 'The East End Way', to: '/the-east-end-way' },
  { label: 'Services', to: '/services' },
  { label: 'Specials', to: '/specials' },
  { label: 'Financing', to: '/financing' },
  { label: 'Reviews', to: '/reviews' },
  { label: 'Contact', to: '/contact' },
]

export const mapEmbedSrc =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d133215.55905742524!2d-84.29857806571366!3d36.039597510203855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885c35618fed1a4d%3A0x571016364ac6f4d6!2sEast%20End%20Automotive%20Repair!5e1!3m2!1sen!2sus!4v1786721526509!5m2!1sen!2sus'

export const financingProviders = [
  {
    name: 'Snap Finance',
    logo: 'https://snap-assets.snapfinance.com/en/us/ecommerce/branding-assets/logos/Snap_logo337X150.jpg',
    learnUrl: 'https://snapfinance.com/how-it-works',
  },
  {
    name: 'Affirm',
    logo: 'https://cdn-assets.affirm.com/images/logo-01-primary.png',
    learnUrl: 'https://www.affirm.com/how-it-works',
  },
  {
    name: 'Klarna',
    logo: 'https://docs.klarna.com/static/assets/Wordmark-Transparent-And-Black.png',
    learnUrl: 'https://www.klarna.com/us/how-klarna-works/',
  },
  {
    name: 'Sunbit',
    logo: 'https://sunbit.com/wp-content/uploads/2026/07/Sunbit_logo_rgb.png',
    learnUrl: 'https://sunbit.com/how-it-works/',
  },
]

export const currentSpecials = [
  {
    title: 'Free Brake Inspection',
    detail: 'With the purchase of brakes.',
    price: 'Free',
    finePrint: '',
    to: '/specials/brake-inspection',
  },
  {
    title: 'A/C Pressure Test',
    detail: 'Complete A/C Pressure Test & System Inspection.',
    price: '$29.99',
    finePrint: 'Plus tax and shop fees.',
    to: '/specials/ac-pressure-test',
  },
  {
    title: '5 qt Oil Change',
    detail: 'Five quart oil change.',
    price: '$49.97',
    finePrint:
      'Before taxes and shop fees. Not all oils apply. Diesel and specialty oils do not apply. Contact us for details.',
    to: '/specials/oil-change',
  },
]

export const acSpecial = {
  name: 'Complete A/C Pressure Test & System Inspection',
  price: 'Only $29.99',
  finePrint: 'Plus tax and shop fees.',
  angle: 'A/C Not Blowing Cold? Don’t Sweat It.',
  pillLabel: '$29.99 A/C Pressure Test & Inspection',
  included: [
    'Comprehensive A/C System Inspection',
    'Refrigerant (Freon) Level Verification',
    'A/C Compressor Performance Test',
    'Interior Vent Temperature Performance Test',
  ],
  inspectionDetails: [
    {
      title: 'System Pressure Test',
      copy: 'Check high and low-pressure sides to ensure the compressor is functioning correctly.',
    },
    {
      title: 'Visual Leak Inspection',
      copy: 'Inspect hoses, lines, and seals for visible signs of refrigerant leaks.',
    },
    {
      title: 'Temperature Output Check',
      copy: 'Measure air temperature from the vents to verify cooling performance.',
    },
  ],
  images: {
    hero: 'https://vibe.filesafe.space/1778980432547963701/assets/3028f9bb-8bf4-48ed-99c8-f2df4695601d.png',
    pressureTest:
      'https://vibe.filesafe.space/1778980432547963701/attachments/9ac98076-6c70-4834-97d2-a58372dc1916.jpg',
  },
}

export type Service = {
  name: string
  description: string
  icon: string
}

export const services: Service[] = [
  {
    name: 'Professional Vehicle Diagnostics',
    description:
      'Up-to-date diagnostic equipment and a documented process to find the real cause, not just the symptom.',
    icon: 'gauge',
  },
  {
    name: 'Standard Maintenance & Oil Changes',
    description:
      'Scheduled maintenance and oil service that keeps your vehicle on the manufacturer’s interval.',
    icon: 'droplet',
  },
  {
    name: 'Auto Electrical Services',
    description:
      'Batteries, charging systems, wiring and electrical faults traced and corrected.',
    icon: 'zap',
  },
  {
    name: 'Engine Service',
    description:
      'Engine performance concerns, repairs and service work handled by trained technicians.',
    icon: 'cog',
  },
  {
    name: 'Exhaust Services',
    description:
      'Exhaust inspection, repair and replacement for noise, leaks and emissions concerns.',
    icon: 'wind',
  },
  {
    name: 'Heating & Air Conditioning Repair',
    description:
      'A/C performance testing, heating concerns and climate control system repair.',
    icon: 'thermometer',
  },
  {
    name: 'Alignment Service',
    description:
      'Alignment work to correct handling, steering pull and uneven tire wear.',
    icon: 'crosshair',
  },
  {
    name: 'Transmission Service',
    description:
      'Transmission service and repair, with a clear explanation of the options before work begins.',
    icon: 'settings2',
  },
  {
    name: 'General Repair & Maintenance',
    description:
      'Brakes, suspension, steering and the everyday repairs that keep your vehicle safe.',
    icon: 'wrench',
  },
]

export const fourCs = [
  {
    label: 'Condition',
    copy: 'We start by confirming exactly what the vehicle is doing — what you experienced, and what we can verify ourselves.',
  },
  {
    label: 'Cause',
    copy: 'We test and diagnose until we know the underlying cause, instead of replacing parts and hoping.',
  },
  {
    label: 'Correction',
    copy: 'We explain the correction, the options, and the tradeoffs so you can make an informed decision.',
  },
  {
    label: 'Confirm',
    copy: 'We verify the repair fixed the original condition before the vehicle goes back to you.',
  },
]

export const trustPoints = [
  { stat: '5.0', label: '93 verified reviews on SureCritic' },
  { stat: '1 yr / 12k mi', label: 'Parts & labor warranty' },
  { stat: 'FCA Factory Trained', label: 'Chrysler · Dodge · Jeep' },
  { stat: '55+ Years', label: 'Combined technician experience' },
  {
    stat: 'Financing',
    label: 'Snap Finance · Affirm · Klarna · Sunbit',
  },
]

export type Testimonial = {
  image: string
  imageAlt: string
  imagePosition?: string
  quote: string
  name: string
  location?: string
  vehicle?: string
  date: string
}

export const testimonials: Testimonial[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/jUbBk7c9EcCVChBmkVdHaS/473001377_459240413902978_3883974652898110632_n.jpg',
    imageAlt:
      'Snap-on scan tool showing live cylinder misfire data during diagnosis on a Dodge Ram pickup.',
    quote: 'His explanations are clear and easy to understand.',
    name: 'Susan G.',
    location: 'Oak Ridge, TN',
    vehicle: 'Dodge Pickup',
    date: '08/12/2026',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/2KJYP74oom5MY65JS3MYtA/508150559_575806618913023_2572858364588318064_n.jpg',
    imageAlt:
      'Lifted Ford F-150 raised on the shop lift during suspension and exhaust work',
    quote: 'Best price and excellent work.',
    name: 'Verified Customer',
    location: 'Powell, TN',
    vehicle: 'Ford F-150',
    date: '07/02/2026',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/tPFa9izrHsSYAKuHZdAtJ3/517100816_594336303726721_1445048959789487300_n.jpg',
    imageAlt:
      'Several vehicles including a BMW sedan with hoods open across the East End Automotive service bays',
    quote: 'Kindness and transparency.',
    name: 'Jordan L.',
    date: '07/21/2026',
  },
]
